import * as React from 'react';

import { MyHomeBanner } from '../../components/MyHomeBanner';

export const MyHomeBannerContainer: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(true);
  const handleClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);

  if (!isVisible) {
    return null;
  }

  return <MyHomeBanner onClose={handleClose} />;
};

MyHomeBannerContainer.displayName = 'MyHomeBannerContainer';
